var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5a6.29 6.29 0 0 0 4 2.06v1.94a.75.75 0 0 1-.32.61l-2.5 1.75A.75.75 0 0 1 6 15.25V9.5zM10.7 0a5.3 5.3 0 1 1 0 10.6 5.3 5.3 0 0 1 0-10.6zm.23 1.6c-.77 0-1.46.16-2.08.48A3.57 3.57 0 0 0 7.42 3.4a3.66 3.66 0 0 0-.52 1.94 3.57 3.57 0 0 0 1.95 3.27c.6.32 1.28.48 2.04.48a5.7 5.7 0 0 0 1.62-.24 4.73 4.73 0 0 0 1.42-.68V5.2h-1.8v1.97a2.63 2.63 0 0 1-1.11.24c-.4 0-.76-.09-1.07-.26a1.85 1.85 0 0 1-.72-.73 2.17 2.17 0 0 1-.26-1.07c0-.62.19-1.12.57-1.5.38-.37.88-.56 1.5-.56.68 0 1.27.27 1.76.8l1.3-1.17a3.5 3.5 0 0 0-1.34-.98 4.64 4.64 0 0 0-1.83-.34zM7.3 0A6.3 6.3 0 0 0 4.4 5.3v.16L.22 1.28A.75.75 0 0 1 .75 0h6.54zm6.82 0h1.14a.75.75 0 0 1 .53 1.28l-.13.13A6.33 6.33 0 0 0 14.11 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalFilter);
export default __webpack_public_path__ + "static/media/global-filter.549fb7b12ab342ce357090008be466c0.svg";
export { ForwardRef as ReactComponent };